if (typeof QuickAddToCart !== 'function') {

  class QuickAddToCart extends HTMLElement {
    constructor() {
      super()
      this.locationPromise = null
      this.productForm = this.querySelector('product-form')
      this.variantSelector = this.querySelector('variant-selector')
      this.defaultAddToCartText = this.getAttribute('data-add-to-cart-text')
      this.defaultOutOfStockText = this.getAttribute('data-out-of-stock-text')
      if (this.productForm) {
        this.addToCart = this.productForm.querySelector('[type="submit"]')
        this.addToCartText = this.addToCart.querySelector('.button__text')
        this.storeSelector = document.querySelector('store-selector[data-main-selector]')
        this.init()
      }
    }

    async init() {
      this.productForm.addEventListener('add-to-cart', () => {
        if (!document.body.classList.contains('template-cart')) {
          document.getElementById('site-cart-sidebar').show()
        }
        if (document.getElementById('cart-recommendations')) {
          document.getElementById('cart-recommendations').generateRecommendations()
        }
        document.querySelectorAll('[data-header-cart-total').forEach(elm => {
          elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent
        })
        document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
          elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent
        })
      })

      if (this.storeSelector) {
        this.storeSelector.addEventListener('storechanged', this.onStoreChanged.bind(this))
      }

      this.addEventListener('variant-selector:changed', this.onVariantChanged.bind(this))
      this.locationPromise = this.getLocation()
      try {
        await this.locationPromise
        this.getVariantData()
        this.onStoreChanged()
      } catch (error) {
        console.error({ error }, 'Failed to get location.')
      }
    }

    async getLocation() {
      try {
        const token = window.KROWN.settings.storefront_api_key;
        const domain = window.KROWN.settings.store_domain;
        const productId = this.getAttribute('data-product-id');
        const originId = this.getAttribute('data-origin-id')
            
			  const query = `#graphql
                query Product($id: ID!) {
                    product(id: $id) {
                        availableForSale
                        id
                        title
                        totalInventory
                        variants(first: 250) {
                            nodes {
                                components(first: 1) {
                                  nodes {
                                    productVariant{
                                      id
                                      storeAvailability (first: 250) {
                                        nodes {
                                          available
                                          location {
                                            id
                                            name
                                          }
                                          quantityAvailable
                                        }
                                      }
                                    }
                                    quantity
                                  }
                                }
                                id
                                title
                                quantityAvailable
                                storeAvailability (first: 250) {
                                    nodes {
                                      available
                                        location {
                                            id
                                            name
                                        }
                                        quantityAvailable
                   
                                    }
                                }
                            }
                        }
                    }
                }
            `
       
            const body = {
                query: query,
                variables: {
                    id: `gid://shopify/Product/${productId}`
                }
            }
            const response = await fetch(`https://${domain}/api/2025-04/graphql.json`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': token
                },
                body: JSON.stringify(body),
            });


        const data = await response.json()

        
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        if(!data.data.product) {
          console.error('Product not found')
          return
        }
        this.locationProduct = data   

      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    getStoreName() {
      const storeName = document.querySelector('#site-store-selector-handle [data-store-label]').getAttribute('data-store-label')
      return storeName
    }

    getVariantData() {
      const variantId = this.getAttribute('data-variant-id')
      const arrayVariantsLocation = this.locationProduct.data
      const variantIds = new Map()
      const storeName = this.getStoreName()

      
      arrayVariantsLocation.product.variants.nodes.forEach((item) => {
        const parsedId = item.id.split('gid://shopify/ProductVariant/')[1]
        const variantElement =  item.title === 'Default Title' ? this : this.variantSelector.querySelector(`.variant-selector__dropdown ul > li[data-variant-id="${parsedId}"]`)
        if(!variantElement) return
        
        const inventory_policy = variantElement.getAttribute('data-inventory-policy')

        const hasComponents = item?.components?.nodes?.length > 0

        const variantsToMap = hasComponents ? item.components.nodes[0].productVariant.storeAvailability.nodes :  item.storeAvailability.nodes

        
        variantsToMap.forEach((storeAvailability) => {
          const loc = storeAvailability
          if (storeAvailability.location.name === storeName) {
            const quantityAvailable = hasComponents ? Math.floor(storeAvailability.quantityAvailable / item.components.nodes[0].quantity) : storeAvailability.quantityAvailable;
            if (inventory_policy === 'continue') {
              variantIds.set(Number(parsedId), true)
            }
            else if (quantityAvailable <= 0) {
              variantIds.set(Number(parsedId), false)
            }
            else {
              variantIds.set(Number(parsedId), true)
            }
          }
        })
      })

      let arrayVariants = JSON.parse(this.querySelector('[type="application/json"]').textContent)
      arrayVariants = arrayVariants.map(v => {
        if (variantIds.has(v.id)) {
          v.available = variantIds.get(v.id)
        }
        return v
      })

      this.variantData = arrayVariants
      this.currentVariant = this.variantData.find((v) => v.id === Number(variantId))
    }

    async onVariantChanged(event) {
      await this.locationPromise
      const { id } = event.detail
      this.setAttribute('data-variant-id', id)
      this.currentVariant = this.variantData.find((v) => v.id === Number(id))
      this.getStoreName()
      this.checkAddToCart()
    }

    async onStoreChanged() {
      await this.locationPromise
      this.getVariantData()
      this.updateUnavailableVariants()
      this.checkAddToCart()
    }

    updateUnavailableVariants() {
      if (this.variantSelector) {
        const items = this.variantSelector.querySelectorAll('[data-variant-id]')
        items.forEach(item => {
          const variantId = Number(item.getAttribute('data-variant-id'))
          const variant = this.variantData.find((v) => v.id === variantId)
          if (variant && variant.available) {
            item.classList.remove('disabled')
          }
          else {
            item.classList.add('disabled')
          }
        })
      }
    }

    checkAddToCart() {
      if (!this.currentVariant || !this.currentVariant.available) {
        this.addToCart.disabled = true
        if (this.addToCartText) {
          this.addToCartText.textContent = this.defaultOutOfStockText
            || window.KROWN.settings.locales.products_sold_out_variant
        }
      } else {
        this.addToCart.disabled = false
        if (this.addToCartText) {
          this.addToCartText.textContent = this.defaultAddToCartText
            || window.KROWN.settings.locales.products_add_to_cart_button
        }
      }
    }
  }

  if (typeof customElements.get('quick-add-to-cart') == 'undefined') {
    customElements.define('quick-add-to-cart', QuickAddToCart)
  }

}

if (typeof QuickViewProduct !== 'function') {

  class QuickViewProduct extends HTMLElement {
    constructor() {
      super()
      if (this.querySelector('a')) {
        this.init()
      }
    }
    init() {

      this.quickViewModal = null
      this.querySelector('a').addEventListener('click', (e) => {

        e.preventDefault()

        if (!this.quickViewModal) {

          const target = e.currentTarget

          target.classList.add('working')

          fetch(`${target.getAttribute('href')}${target.getAttribute('href').includes('?') ? '&' : '?'}view=quick-view`)
            .then(response => response.text())
            .then(text => {

              const quickViewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#product-quick-view')

              // create modal w content

              const quickViewContainer = document.createElement('div')
              quickViewContainer.innerHTML = `<modal-box id="modal-${target.dataset.id}"
								class="modal modal--product"
								data-options='{
									"enabled": false,
									"showOnce": false,
									"blockTabNavigation": true
								}'
								tabindex="-1" role="dialog" aria-modal="true"
							>
								<div class="container--medium">
									<div class="modal-content">
										<button class="modal-close" data-js-close data-js-first-focus style="position:absolute;margin:0;top:0;right:0">${window.KROWN.settings.symbols.close}</button>
									</div>
								</div>
								<span class="modal-background" data-js-close></span>
							</modal-box>`

              this.quickViewModal = quickViewContainer.querySelector('modal-box')
              document.body.appendChild(this.quickViewModal)

              this.quickViewModal.querySelector('.modal-content').innerHTML = quickViewHTML.innerHTML

              if (!window.productPageScripts) {

                const scripts = this.quickViewModal.querySelectorAll('script')
                scripts.forEach(elm => {
                  const script = document.createElement('script')
                  script.src = elm.src
                  document.body.append(script)
                  window.productPageScripts = true
                })

              }

              this.quickViewModal.querySelector('.product-quick-view__close').addEventListener('click', () => {
                this.quickViewModal.hide()
              })

              if (this.quickViewModal.querySelector('[data-js-product-form]')) {
                this.quickViewModal.querySelector('[data-js-product-form]').addEventListener('add-to-cart', () => {
                  this.quickViewModal.hide()
                })
              }

              setTimeout(() => {
                this.quickViewModal.show()
                target.classList.remove('working')
              }, 250)

            })

        } else {
          this.quickViewModal.show()
        }

      })
    }
  }

  if (typeof customElements.get('quick-view-product') == 'undefined') {
    customElements.define('quick-view-product', QuickViewProduct)
  }

}

if (typeof VariantSelector !== 'function') {
  class VariantSelector extends HTMLElement {
    constructor() {
      super()
      if (this.querySelector('details')) {
        this.init()
      }
    }
    init() {
      const input = this.querySelector('[name="id"]')
      const details = this.querySelector('details')

      details.addEventListener('click', (event) => {
        const item = event.target.closest('li')
        if (item) {
          const id = item.getAttribute('data-variant-id')
          const label = item.getAttribute('data-variant-label')
          const title = item.getAttribute('data-variant-title')
          this.querySelector('summary [data-variant-title]').textContent = title
          this.querySelector('summary [data-variant-label]').textContent = label

          const items = details.querySelectorAll('ul > li')

          items.forEach(item => {
            item.classList.remove('selected')
          })

          item.classList.add('selected')

          if (input) {
            input.value = id
          }
          details.open = false
          this.dispatchEvent(new CustomEvent('variant-selector:changed', {
            bubbles: true,
            detail: { id }
          }))
        }
      })
      document.addEventListener('click', (event) => {
        if (!details.contains(event.target) && details.open) {
          details.open = false
        }
      })
    }
  }

  if (typeof customElements.get('variant-selector') == 'undefined') {
    customElements.define('variant-selector', VariantSelector)
  }
}

if (typeof WishListButton !== 'function') {
  class WishListButton extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = []
      }
      window.SwymCallbacks.push(this.init.bind(this))
    }

    init(swatInstance) {
      this.swat = swatInstance
      window.swat = swatInstance
      this.addButton = this.querySelector('[data-swaction="addToWishlist"]')
      this.removeButton = this.querySelector('[data-swaction="removeFromWishlist"]')
      if (this.removeButton) {
        this.removeButton.addEventListener('click', this.handleRemoveFromWishlist.bind(this))
      }
      this.updateVariant()
    }

    updateVariant() {
      const product = this.closest('.product-item')
      const button = this.querySelector('button')
      if (product) {
        product.addEventListener('variant-selector:changed', (event) => {
          button.setAttribute('data-variant-id', event.detail.id)
          this.swat.initializeActionButtons('body')
        })
      }
    }

    handleRemoveFromWishlist() {
      const epi = this.addButton.dataset.variantId
      this.swat.removeFromWishList({ epi }, (event) => {
        this.addButton.classList.value = 'add-to-wishlist'
        this.swat.initializeActionButtons('body')
      })
    }
  }

  if (typeof customElements.get('wish-list-button') == 'undefined') {
    customElements.define('wish-list-button', WishListButton)
  }
}
